<app-header></app-header>

<bit-container>
  <div class="bv-preferences-page">
    <p class="bv-preferences-page__desc">{{ "preferencesDesc" | i18n }}</p>

    <form [formGroup]="form" (ngSubmit)="submit()">
      @if (availableTimeoutOptions$ | async; as timeoutOptions) {
        <bit-session-timeout-input
          [availableTimeoutOptions]="timeoutOptions"
          [formControl]="form.controls.timeout"
        ></bit-session-timeout-input>
      }

      <bit-radio-group
        formControlName="timeoutAction"
        [block]="true"
        class="bv-preferences-timeout-action"
      >
        <bit-label>{{ "vaultTimeoutAction" | i18n }}</bit-label>

        @if (availableTimeoutActions().includes(VaultTimeoutAction.Lock)) {
          <bit-form-control disableMargin>
            <input type="radio" bitRadio [value]="VaultTimeoutAction.Lock" />
            <bit-label>{{ "lock" | i18n }}</bit-label>
            <bit-hint>{{ "vaultTimeoutActionLockDesc" | i18n }}</bit-hint>
          </bit-form-control>
        }

        @if (availableTimeoutActions().includes(VaultTimeoutAction.LogOut)) {
          <bit-form-control disableMargin>
            <input type="radio" bitRadio [value]="VaultTimeoutAction.LogOut" />
            <bit-label>{{ "logOut" | i18n }}</bit-label>
            <bit-hint>{{ "vaultTimeoutActionLogOutDesc" | i18n }}</bit-hint>
          </bit-form-control>
        }

        @if (isTimeoutSuppressed()) {
          <p class="bv-preferences-page__policy-hint">
            {{ "sessionTimeoutSuppressedByConnectedDevice" | i18n }}
          </p>
        } @else if (sessionTimeoutActionFromPolicy() != null) {
          <p class="bv-preferences-page__policy-hint">
            {{ "sessionTimeoutSettingsManagedByOrganization" | i18n }}
          </p>
        }
      </bit-radio-group>

      <bit-form-field class="bv-mat-field tw-w-full">
        <bit-label>{{ "language" | i18n }}</bit-label>
        <bit-select formControlName="locale" id="locale">
          @for (option of localeOptions; track option.value) {
            <bit-option [value]="option.value" [label]="option.name"></bit-option>
          }
        </bit-select>
        <bit-hint>{{ "languageDesc" | i18n }}</bit-hint>
      </bit-form-field>

      <bit-form-control class="bv-preferences-favicons" disableMargin>
        <input type="checkbox" bitCheckbox formControlName="enableFavicons" />
        <bit-label>{{ "showWebsiteIcons" | i18n }}</bit-label>
        <bit-hint>{{ "showWebsiteIconsDesc" | i18n }}</bit-hint>
      </bit-form-control>

      <bit-form-field class="bv-mat-field tw-w-full">
        <bit-label>{{ "theme" | i18n }}</bit-label>
        <bit-select formControlName="theme" id="theme">
          @for (option of themeOptions; track option.value) {
            <bit-option [value]="option.value" [label]="option.name"></bit-option>
          }
        </bit-select>
        <bit-hint>{{ "themeDesc" | i18n }}</bit-hint>
      </bit-form-field>

      <button
        bitButton
        type="submit"
        buttonType="primary"
        class="bv-preferences-page__save-btn"
        [disabled]="isTimeoutSuppressed()"
      >
        {{ "save" | i18n }}
      </button>
    </form>
  </div>
</bit-container>
